@import 'styles/mixins';
@import 'styles/variables';

.leaveText {
  @include ui-md-text;

  color: $red-40;
  cursor: pointer;
}

.header {
  @include xl-semibold;

  color: $gray-90;
}

.settingsContent {
  margin-top: 32px;
}

.showPortal {
  margin-top: 6px;
}

.modalFooter {
  width: 100%;
  text-align: right;

  button + button {
    margin-left: 16px;
  }
}

.settingsSection + .settingsSection {
  border-top: 1px solid $gray-20;
  padding-top: 36px;
}

.formRow {
  display: flex;
  justify-content: space-between;
  margin-bottom: 38px;

  header {
    @include lg-semibold;

    color: $gray-90;
    margin: 0 32px 8px 0;
  }
}

.explanation {
  @include body-sm-text;

  color: $gray-40;
  margin: 0;
}

.customizeLink {
  @include ui-lg-text;

  color: $green-50;

  &:hover {
    color: $green-60;
  }
}

.settingsSection {
  padding-bottom: 36px;

  .settingsOption {
    .toggleRow {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    .helpText {
      @include md-regular;
      color: $grey-40;
      margin-top: 8px;
      width: 75%;
    }

    .optionHeader {
      @include md-semibold;

      color: $gray-90;
      display: flex;
      align-items: center;
    }

    .optionsHeaderSubText {
      @include md-regular;

      font-style: italic;
      margin-left: 4px;
      text-decoration: underline;
    }

    .inputRow {
      flex-direction: column;
      align-items: flex-start;
    }

    &.floatedUp {
      float: right;
      margin-top: -26px;
    }
  }

  .settingsOption + .settingsOption {
    margin-top: 32px;
  }
}

.samlScimInput {
  border: 1px solid var(--dark-15);
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 10px;

  &:focus {
    border: 1px solid transparent;
    box-shadow: 0 0 0 2px var(--selected-stroke);
  }
}

.infoIcon {
  fill: $gray-40;
  margin-left: 2px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.importantSection {
  padding: 16px;
  border-radius: 8px;
  background-color: $grey-5;
}

@include for-phone-only {
  .settingsSection {
    .settingsOption {
      .helpText {
        width: 100%;
      }
    }
  }
}
